import type { ChangeEventHandler } from 'react';
import Styles from './Radio.module.scss';
export interface RadioProps {
    id: string;
    value: string | number;
    name: string;
    checked: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
}
function Radio({ id, value, name, onChange, checked }: Readonly<RadioProps>): React.ReactElement {
    return (
        <div className={Styles.radio}>
            <label className={Styles.label} htmlFor={id}>{id}</label>
            <input className={Styles.button} id={id} type="radio" value={value} name={name} onChange={onChange} checked={checked} />
        </div>
    );
}

export default Radio;
